import type { ConciergeCard } from "@/hooks/useAiConcierge";
import ConciergeListingCard from "./ConciergeListingCard";

interface Props {
  cards: ConciergeCard[];
  onOpenDetail: (slug: string) => void;
  /** Column layout; the default fits the desktop takeover's right pane. */
  gridClassName?: string;
}

/**
 * Desktop-only right pane of the full-screen concierge. Aggregates every
 * listing surfaced across the conversation so browsing is comfortable and the
 * chat thread on the left stays clean.
 */
const ConciergeListingsPanel = ({
  cards,
  onOpenDetail,
  gridClassName = "grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4",
}: Props) => (
  <div className="flex h-full min-h-0 flex-col bg-muted/20">
    <div className="shrink-0 border-b px-4 py-3">
      <h3 className="text-sm font-semibold">Your matches</h3>
      <p className="text-[12px] text-muted-foreground">
        {cards.length > 0
          ? `${cards.length} ${cards.length === 1 ? "home" : "homes"} so far`
          : "Listings collect here as we chat"}
      </p>
    </div>
    <div className="flex-1 overflow-y-auto p-4">
      {cards.length > 0 ? (
        <div className={`grid gap-4 ${gridClassName}`}>
          {cards.map((c) => (
            <ConciergeListingCard key={c.slug} card={c} onOpenDetail={onOpenDetail} />
          ))}
        </div>
      ) : (
        <div className="flex h-full items-center justify-center px-6 text-center text-[13px] text-muted-foreground">
          Tell me what you're looking for and I'll gather matches here.
        </div>
      )}
    </div>
  </div>
);

export default ConciergeListingsPanel;
